<template>
  <App />
</template>
<script>
  import { App } from "sw-hic";
  export default {
    components: {
      App: App,
    },
  };
</script>
<style>
  /*病历编辑*/
  .editor .el-dialog .el-dialog__body {
    position: absolute;
    left: 0;
    top: 54px;
    bottom: 70px;
    right: 0;
    padding: 0;
    z-index: 1;
    overflow: hidden;
    overflow-y: auto;
  }
  .editor .el-dialog .el-dialog__footer {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
  }
</style>
